"use client";

import styled from "styled-components";
import Icon from "@/components/icon";

export const BoxSelect = styled.div`
  border: 1px solid var(--borderColor);
  border-radius: 7px;
  position: relative;
  height: 40px;
`;

export const SelectComponent = styled.input`
  height: 40px;
  width: 100%;
  box-shadow: none;
  padding: 5px 30px 5px 10px;
  font-size: 14px;
  font-weight: normal;
  font-family: "Outfit", sans-serif;
  color: var(--colorTitle);
  border-radius: 7px;
  border: none;
  background: transparent;
  cursor: pointer;

  &:focus {
    border: none;
    box-shadow: none;
    outline: none;
  }

  &::placeholder {
    color: var(--colorTitle);
    opacity: 0.7;
  }
`;

export const IconComponent = styled(Icon)`
  position: absolute;
  top: 50%;
  margin-top: -3.5px;
  right: 12px;
  z-index: 0;

  svg {
    fill: var(--colorTitle);
    path {
      fill: transparent;
      stroke: var(--colorTitle);
    }
  }
`;

export const OptionsList = styled.ul`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 10;
  background: var(--backgroundColorCard);
  border: 1px solid var(--borderColor);
  border-top: none;
  max-height: 200px;
  overflow-y: auto;
  border-radius: 0 0 7px 7px;
`;

export const OptionItem = styled.li<{
  $isSelected?: boolean;
  $isDisabled?: boolean;
}>`
  padding: 10px;
  font-size: 14px;
  cursor: ${({ $isDisabled }) => ($isDisabled ? "not-allowed" : "pointer")};
  background-color: ${({ $isSelected }) =>
    $isSelected ? "var(--primarySystem)" : "var(--backgroundColorCard)"};
  color: ${({ $isDisabled }) => ($isDisabled ? "#999" : "var(--colorTitle)")};
  font-style: ${({ $isDisabled }) => ($isDisabled ? "italic" : "normal")};
  pointer-events: ${({ $isDisabled }) => ($isDisabled ? "none" : "auto")};
  transition: background-color 0.2s ease;

  &:hover {
    background-color: var(--primarySystem);
    color: var(--colorTitle);
  }
`;
